import { render, staticRenderFns } from "./ContentAdministratorList.vue?vue&type=template&id=24d51268&scoped=true&"
import script from "./ContentAdministratorList.vue?vue&type=script&lang=js&"
export * from "./ContentAdministratorList.vue?vue&type=script&lang=js&"
import style0 from "./ContentAdministratorList.vue?vue&type=style&index=0&id=24d51268&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d51268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
